import { render, staticRenderFns } from "./ExpiredMessage.vue?vue&type=template&id=a2dad588&scoped=true&"
import script from "./ExpiredMessage.vue?vue&type=script&lang=js&"
export * from "./ExpiredMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredMessage.vue?vue&type=style&index=0&id=a2dad588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dad588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
